import { render, staticRenderFns } from "./Coffee.vue?vue&type=template&id=36ee276a&"
import script from "./Coffee.vue?vue&type=script&lang=js&"
export * from "./Coffee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports